<template>
  <section class="section--comp">
    <div class="container lg:w-4/5">
      <vx-card no-shadow card-background="#F7F8F9">
        <div class="tips-heading mb-base">
          5 Tips to implement competency development model and creating
          inclusive Training program
        </div>
        <ul class="tips-list">
          <li>
            <vs-icon
              class="mr-3"
              color="#F29300"
              icon="icon-check-circle"
              icon-pack="feather"
            />Design backwards by starting with a large concept, then make a
            module for each smaller skill.
          </li>
          <li>
            <vs-icon
              class="mr-3"
              color="#F29300"
              icon="icon-check-circle"
              icon-pack="feather"
            />Develop a competency checklist for each larger skill so employees
            can create personalized learning journeys and access the modules
            they need on demand.
          </li>
          <li>
            <vs-icon
              class="mr-3"
              color="#F29300"
              icon="icon-check-circle"
              icon-pack="feather"
            />Tell your learner which part of the larger skill they are working
            on at the beginning of the module.
          </li>
          <li>
            <vs-icon
              class="mr-3"
              color="#F29300"
              icon="icon-check-circle"
              icon-pack="feather"
            />Incorporate “breadcrumbs” into the platform (those little strings
            of navigation menu that pop up on websites) so learners know where
            they are in their skill development.
          </li>
          <li>
            <vs-icon
              class="mr-3"
              color="#F29300"
              icon="icon-check-circle"
              icon-pack="feather"
            />Provide links to extra information at the end of the module to
            continue exploration
          </li>
        </ul>
      </vx-card>
    </div>
  </section>
</template>

<script>
export default {
  name: "Tips",
};
</script>

<style scoped>
.tips-heading {
  font-style: normal;
  font-weight: 800;
  font-size: 20px;
  line-height: 27px;
  color: #231d4f;
}

.tips-list li {
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 19px;
  color: #231d4f;
  flex: none;
  order: 1;
  flex-grow: 0;
  margin: 20px 0px;
}

 /* @media (max-width: 1200px) {
  section {
    padding: 10rem 0;
  }
} */
</style>
